import React, { useEffect, useState } from 'react';
import {
  Box,
  ButtonBase,
  Checkbox,
  Dialog,
  FormControlLabel,
  IconButton,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { CloseIcon } from '../../../../../components/Icon';
import { i18n } from '../../../../../language';
import { baseCssOccupieddischarge } from '../baseCss';
import BottonStatusIcon from '../../BedStatusIcon/BottonStatusIcon';
import { BEDSTATUS_CHOOSE_FILTER } from '../../../../../comm/constant';
import { filterOption, statusP } from '../../../bsApp';
import RemaksIcon from '../../BedStatusIcon/RemaksIcon';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '81.25rem',
    minWidth: '41.25rem',
    borderRadius: '0.937rem',
    background: '#fff',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },
  option: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1rem',
    fontWeight: 'bold',
    color: '#538fff',
    marginBottom: '0.688rem',
  },
  checkBox: {
    display: 'flex',
    margin: '0',
    '& .MuiCheckbox-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      fontWeight: '500',
      color: '#2e4469',
      margin: '0.8rem 0',
    },
    '& .Mui-checked': {
      color: '#28d2ab',
    },
  },
  line: {
    border: 'solid 1px #e4e7eb',
    margin: '1.8rem 1.563rem 1.8rem 1.563rem',
  },
  remaksIcon: {
    margin: '0 1rem',
  },
  showBed: {
    // fontFamily: 'NotoSans-SemiBold',
    fontSize: '1.125rem',
    fontWeight: '600',
    color: '#2e4469',
    padding: '0 1.875rem 0.625rem',
  },
}));

export default function ChooseFilter({ open, closePop, confirmHandle, allData }) {
  const classes = useStyles();
  const baseClasses = baseCssOccupieddischarge();
  const options = filterOption.map((optionItem) => {
    return optionItem.map((item) => {
      return allData[item];
    });
  });
  const _options = options.map((item, index) => ({
    key: index,
    value: item.map((item, index) => ({
      key: index,
      value: item,
    })),
  }));

  const [ValueData, setValueData] = useState(null);
  useEffect(() => {
    try {
      const filterStorage = sessionStorage.getItem(BEDSTATUS_CHOOSE_FILTER);
      setValueData(JSON.parse(filterStorage));
    } catch {
      setValueData({});
    }
  }, []);

  const onChangeHandle = (type, key) => {
    return (event) => {
      if (type === 'check') {
        setValueData({ ...ValueData, [key]: event.target.checked });
      } else if (type === 'selectAll') {
        const newValueData = { ...ValueData };
        options[key].forEach((item) => {
          newValueData[item?.typeName] = event.target.checked;
        });
        setValueData(newValueData);
      }
    };
  };

  const IsSelectAll = (index) => {
    return (
      options[index].filter((item) => {
        return ValueData?.[item?.typeName];
      }).length === options[index].length
    );
  };

  const confirmClick = () => {
    confirmHandle?.(ValueData);
  };

  const resetHandle = () => {
    const newValueData = { ...ValueData };
    const itemOption = options[0].map((item) => item?.typeName);
    Object.keys(newValueData).forEach((item) => {
      newValueData[item] = itemOption.includes(item);
    });
    confirmHandle?.(newValueData);
  };

  return (
    <Dialog open={open} maxWidth={false}>
      <div className={classes.root}>
        <div className={baseClasses.header} style={{ padding: '1.675rem 1.563rem 0rem' }}>
          <Typography className={baseClasses.headerTitle}>{i18n.t('BEDSTATUS_CHOOSE_FILTER')}</Typography>
          <IconButton id="bed_choosefilter_close" className={baseClasses.closeIcon} onClick={closePop}>
            <CloseIcon />
          </IconButton>
        </div>
        <main style={{ overflow: 'auto' }}>
          {_options.map(({ key, value: optionItem }) => {
            const statusList = Object.values(statusP);
            return (
              <React.Fragment key={key}>
                {key === 1 ? (
                  <>
                    <div className={classes.line} />
                    <Typography className={classes.showBed}>
                      {i18n.t('BEDSTATUS_SHOW_BEDS_WITH_FOLLOWING_REMARKS_ONLY')}
                    </Typography>
                  </>
                ) : (
                  ''
                )}
                <Box display="flex">
                  <FormControlLabel
                    id={`bed_choosefilter_selectAll_${key}`}
                    control={<Checkbox />}
                    label={i18n.t('BEDSTATUS_SELECT_ALL')}
                    checked={IsSelectAll(key)}
                    className={classes.checkBox}
                    onChange={onChangeHandle('selectAll', key)}
                    style={{ margin: '0.625rem 1.875rem 0 1.875rem' }}
                  />
                </Box>
                <Box p="0 1.875rem 0 " display="flex" flexWrap="wrap">
                  {optionItem.map(({ key, value: item }) => {
                    return (
                      <React.Fragment key={item?.text + key}>
                        <Box display="flex" style={{ width: '33%' }}>
                          <FormControlLabel
                            id={`bed_choosefilter_${item?.text}`}
                            control={item ? <Checkbox /> : <div />}
                            label={
                              <Box display="flex" alignItems="center" whiteSpace="nowrap">
                                {statusList.includes(item?.typeName) ? (
                                  <BottonStatusIcon typeName={item?.typeName} className={classes.remaksIcon} />
                                ) : (
                                  <>
                                    <RemaksIcon typeName={item?.typeName} className={classes.remaksIcon} />
                                    {item?.typeName2 && (
                                      <>
                                        <div style={{ fontSize: '1rem', margin: '0 -0.8rem' }}>/</div>
                                        <RemaksIcon typeName={item?.typeName2} className={classes.remaksIcon} />
                                      </>
                                    )}
                                  </>
                                )}
                                {item?.text}
                              </Box>
                            }
                            className={classes.checkBox}
                            checked={ValueData?.[item?.typeName]}
                            onChange={onChangeHandle('check', item?.typeName)}
                          />
                        </Box>
                      </React.Fragment>
                    );
                  })}
                </Box>
              </React.Fragment>
            );
          })}
        </main>
        <div className={baseClasses.bottom} style={{ border: 'solid 1px #e4e7eb' }}>
          <ButtonBase
            id="bed_choosefilter_clear"
            className={baseClasses.cancelBtn}
            style={{ marginRight: '1.25rem' }}
            onClick={resetHandle}
          >
            {i18n.t('BEDSTATUS_CLEAR')}
          </ButtonBase>
          <ButtonBase id="bed_choosefilter_apply" className={baseClasses.configBtn} onClick={confirmClick}>
            {i18n.t('BEDSTATUS_APPLY')}
          </ButtonBase>
        </div>
      </div>
    </Dialog>
  );
}
